// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"841733ba","143":"516b50fd","239":"e3a0e86f","453":"06ac39a6","455":"4cdd6bb6","762":"fb25f928","977":"4cc9554f"}[chunkId] + ".chunk.js";
};